import { render } from "./SchedaContenuto.vue?vue&type=template&id=06a6b285"
import script from "./SchedaContenuto.vue?vue&type=script&lang=js"
export * from "./SchedaContenuto.vue?vue&type=script&lang=js"

import "./SchedaContenuto.vue?vue&type=style&index=0&id=06a6b285&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__